module.exports = __webpack_public_path__ + "img/au-tas.dd220d60.svg";